import { tv } from "@pcln/horizon";
const bundleAndSave = tv({
    slots: {
        group: 'flex w-full min-w-0 @3xl:h-full',
        options: 'flex flex-row items-center'
    },
    variants: {
        highlightBackground: {
            false: {
                group: 'flex-col gap-3 @sm:flex-row @sm:flex-wrap @sm:items-center @sm:gap-4',
                options: 'flex-wrap gap-4'
            },
            true: {
                group: 'flex-row flex-wrap items-center gap-x-3 gap-y-2 @sm:gap-x-4',
                options: 'shrink-0 flex-nowrap gap-3 @sm:gap-4'
            }
        },
        removeBackground: {
            false: {
                group: 'rounded-lg px-2 py-3'
            },
            true: {
                group: 'rounded-none px-0 py-2'
            }
        }
    },
    compoundVariants: [
        {
            highlightBackground: false,
            removeBackground: false,
            class: {
                group: '@3xl:bg-highlight-3'
            }
        },
        {
            highlightBackground: true,
            removeBackground: false,
            class: {
                group: 'bg-highlight-3 px-4 py-5'
            }
        }
    ],
    defaultVariants: {
        highlightBackground: false,
        removeBackground: false
    }
});
export { bundleAndSave };
